var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inline-flex h-8 items-center justify-center gap-1 rounded-md border border-gray-300 bg-white px-3 hover:cursor-pointer hover:bg-gray-200",on:{"click":() =>_vm.$emit('click')}},[_c('div',{staticClass:"text-sm font-medium leading-tight text-zinc-800"},[_vm._v(_vm._s(_vm.$t("flow.go_back")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }